/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EnergyCertificateClassEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export const EnergyCertificateClassEnum = {
    NUMBER_1: 1 as EnergyCertificateClassEnum,
    NUMBER_2: 2 as EnergyCertificateClassEnum,
    NUMBER_3: 3 as EnergyCertificateClassEnum,
    NUMBER_4: 4 as EnergyCertificateClassEnum,
    NUMBER_5: 5 as EnergyCertificateClassEnum,
    NUMBER_6: 6 as EnergyCertificateClassEnum,
    NUMBER_7: 7 as EnergyCertificateClassEnum
};

